module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    staticClass: "showLargeScreenOnly webHeaderBackground",
    staticStyle: {
      "z-index": "600"
    },
    attrs: {
      "type": "faded"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "heritage largescreen",
    attrs: {
      "src": _vm.imgVarsLong,
      "alt": "MoneyRoad"
    },
    on: {
      "click": _vm.loadAccueil
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "heritage middlescreen",
    attrs: {
      "src": _vm.imgVarsShort,
      "alt": "MoneyRoad"
    },
    on: {
      "click": _vm.loadAccueil
    }
  })]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "m-auto",
    attrs: {
      "fill": ""
    }
  }, _vm._l((_vm.menu), function(item, id) {
    return (!_vm.isDisabledItem(item)) ? _c('span', {
      staticStyle: {
        "height": "35px"
      }
    }, [(item.list) ? _c('div', {
      on: {
        "mouseover": function($event) {
          return _vm.autoDropdown(true, 'dropdown' + id)
        },
        "mouseleave": function($event) {
          return _vm.autoDropdown(false, 'dropdown' + id)
        }
      }
    }, [_c('b-nav-item-dropdown', {
      ref: 'dropdown' + id,
      refInFor: true,
      staticClass: "h6 col-sm-3 dropDownInner",
      attrs: {
        "toggle-class": "text-menu font-weight-bold",
        "text": _vm.$t(item.title).toUpperCase()
      }
    }, [_c('b-dropdown-group', {
      staticStyle: {
        "top": "50px"
      }
    }, _vm._l((item.list), function(subitem) {
      return (subitem.enabled && _vm.canShowSpecific(subitem)) ? _c('b-dropdown-item', {
        key: subitem.id,
        class: subitem.id === 0 ? 'subItemMenu' : 'subItemText',
        attrs: {
          "disabled": _vm.isDisabledItem(subitem)
        },
        on: {
          "click": function($event) {
            return _vm.getClicked(subitem)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.$t(subitem.title)) + "\n              "), (!subitem.link) ? _c('span', {
        staticClass: "disabled ml-1"
      }, [_vm._v(_vm._s(_vm.$t('common.dsbld')))]) : _vm._e()]) : _vm._e()
    }), 1)], 1)], 1) : _c('b-nav-item', {
      staticClass: "h6 col-sm-3 text-menu font-weight-bold",
      attrs: {
        "disabled": _vm.isDisabledItem(item)
      },
      on: {
        "click": function($event) {
          return _vm.getClicked(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(item.title).toUpperCase()) + "\n        "), (!item.link) ? _c('span', {
      staticClass: "disabled ml-1"
    }, [_vm._v(_vm._s(_vm.$t('common.dsbld')))]) : _vm._e()])], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto",
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "fill": ""
    }
  }, [_c('div', {
    on: {
      "mouseover": function($event) {
        return _vm.autoDropdown(true, 'log')
      },
      "mouseleave": function($event) {
        return _vm.autoDropdown(false, 'log')
      }
    }
  }, [(this.$engine.user && this.$engine.user.userAccountId !== 1) ? _c('b-nav-item-dropdown', {
    ref: "log",
    staticClass: "logOut",
    attrs: {
      "toggle-class": "text-menu",
      "right": "",
      "variant": "link"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function() {
        return [_c('span', {
          staticClass: "mr-2 h5 text-menu",
          model: {
            value: (_vm.userName),
            callback: function($$v) {
              _vm.userName = $$v
            },
            expression: "userName"
          }
        }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('img', {
          staticClass: "navbarProfileImage",
          attrs: {
            "src": _vm.logoProfile
          }
        })]
      },
      proxy: true
    }], null, false, 1309083473)
  }, [_vm._v(" "), _c('b-dropdown-item', {
    staticClass: "subItemText",
    on: {
      "click": function($event) {
        return _vm.goToLink('/profile/')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('leftPanelTitle.my_prfl')))]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "subItemText",
    on: {
      "click": _vm.activateModalProfile
    }
  }, [_vm._v(_vm._s(_vm.$t('leftPanelTitle.swtch_prfl')))]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "subItemText",
    attrs: {
      "disabled": _vm.$engine.rights.rightIs('settings_consulter', false)
    },
    on: {
      "click": function($event) {
        return _vm.goToLink('/settings/application/')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Webheader.settings')))]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "subItemText",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(this.$t('leftPanelTitle.lgout')))])], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40bc501f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40bc501f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/WebHeader.vue
// module id = 2340
// module chunks = 2